import React, { useState } from 'react';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useSelector } from 'react-redux';
import Logo from './Logo';
import NavTabs from './NavTabs';
import ProfileMenu from './ProfileMenu';
import CreditsBadge from './CreditsBadge';
import LanguageSwitcher from './LanguageSwitcher';
import MobileDrawer from './MobileDrawer';
import useAuthAction from '../../hooks/useAuthAction';
import useRefreshCompany from '../../hooks/useRefreshCompany';
import { topbarTokens as t } from './tokens';

export default function Topbar() {
    const loggedIn = useSelector((state) => state.user.loggedIn);
    const language = useSelector((state) => state.user.language);
    const credits = useSelector((state) => state.user.company?.credits);
    const handleAuthAction = useAuthAction();
    useRefreshCompany();

    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <AppBar
            position="static"
            elevation={0}
            sx={{
                backgroundColor: t.color.surface,
                color: t.color.fg,
                borderBottom: `1px solid ${t.color.divider}`,
                fontFamily: t.font.sans,
            }}
        >
            <Toolbar
                sx={{
                    minHeight: t.height,
                    px: { xs: 2, md: 3 },
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                }}
            >
                <Logo/>

                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                    <NavTabs language={language}/>
                </Box>

                <Box sx={{
                    display: { xs: 'none', md: 'inline-flex' },
                    alignItems: 'center',
                    gap: 1.5,
                }}>
                    {Number.isFinite(credits) && (
                        <CreditsBadge credits={credits} language={language}/>
                    )}
                    <LanguageSwitcher/>
                    <Box sx={{
                        width: '1px',
                        height: 24,
                        backgroundColor: t.color.divider,
                    }}/>
                    <ProfileMenu language={language}/>
                </Box>

                <IconButton
                    onClick={() => setDrawerOpen(true)}
                    aria-label="Open navigation menu"
                    sx={{
                        display: { xs: 'inline-flex', md: 'none' },
                        ml: 'auto',
                        color: t.color.fg,
                    }}
                >
                    <MenuIcon/>
                </IconButton>
            </Toolbar>

            <MobileDrawer
                open={drawerOpen}
                onOpen={() => setDrawerOpen(true)}
                onClose={() => setDrawerOpen(false)}
                language={language}
                loggedIn={loggedIn}
                credits={credits}
                onAuthAction={handleAuthAction}
            />
        </AppBar>
    );
}
